import ContactsView from "./ContactsView";

export default ContactsView;
